import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { ContactSupportForm } from '@adthlete/shared-frontend'
import { Link } from 'react-router-dom'

const Help = () => {
  return (
    <div className="pb-4 max-w-2xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Help & Support</h1>
        <p className="text-gray-600">Get in touch with our team and we'll be happy to help.</p>
      </div>

      <Card variant="dark">
        <CardHeader>
          <CardTitle className="text-foreground">Contact Support</CardTitle>
          <CardDescription className="text-gray-600">
            Send us a message and we'll get back to you within one business day.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ContactSupportForm />
        </CardContent>
      </Card>

      <Card variant="dark" className="mt-6">
        <CardHeader>
          <CardTitle className="text-foreground">Legal</CardTitle>
        </CardHeader>
        <CardContent>
          <Link to="/terms" className="text-[#4d7c0f] hover:text-[#a8e45a] underline">
            Terms of Use & Privacy Policy
          </Link>
        </CardContent>
      </Card>
    </div>
  )
}

export default Help
